import React from 'react';

import Grid from '@mui/material/Grid'
import ImgMediaCard from './cardAbility';

import services from '../../assets/images/services.jpg'
import international from '../../assets/images/international.jpg'
import domestic from '../../assets/images/domestic.jpg'

import { useTranslation } from 'react-i18next';
import '../../i18n' // Import i18n configuration

const OurAbility = () => {
        const { t } = useTranslation(); // t is the translation function
        return (
            <section className="white-section" id="Menu">
                <div className="container-fluid">

                <h2 className="section-heading">{t('aboutPage:intro-title')}</h2>
                <p>{t('aboutPage:intro-context')}</p>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                    <ImgMediaCard
                    image={domestic}
                    name={t('aboutPage:domestic')}
                    description={t('aboutPage:domestic-content')}
                    />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <ImgMediaCard
                    image={international}
                    name={t('aboutPage:international')}
                    description={t('aboutPage:international-content')}
                    />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <ImgMediaCard
                    image={services}
                    name={t('aboutPage:otherServices')}
                    description={t('aboutPage:otherServices-content')}
                    />
                    </Grid>
                </Grid>
                </div>
  </section>

)}
export default OurAbility;